export default __webpack_public_path__ + "static/media/volume-mute-icon.cf4df552.svg";